import { useEffect, useState } from "react";
import {
  State,
  VectorTile as VectorTileSource,
} from "../../../../reactOL/source";
import MVT from "ol/format/MVT.js";
import VectorTile from "../../../../reactOL/layers/VectorTile";
import { useViewContext } from "../../../../../context/View/ViewContext";
import { Style, Stroke } from "ol/style";
import { useGetRouteLineParams } from "../controls";

interface RouteLineVectorTileLayerProps {
  visible: boolean;
}

const routeLineStyle = new Style({
  stroke: new Stroke({
    color: "rgba(68, 0, 255, 0.4)",
    width: 5,
    lineCap: "round",
    lineJoin: "round",
  }),
});

const buildUrl = (quarter: string) =>
  `${process.env.REACT_APP_DATAVIEWER_ROUTELINE_URL}${quarter}/{z}/{x}/{y}.mvt`;

const RouteLineVectorTileLayer = ({
  visible,
}: RouteLineVectorTileLayerProps) => {
  const { projection, tileGrid, setLoading } = useViewContext();
  const { quarter } = useGetRouteLineParams();

  const [routeLineTileSource] = useState(
    VectorTileSource({
      url: `${process.env.REACT_APP_DATAVIEWER_ROUTELINE_URL}{z}/{x}/{y}.mvt`,
      onStateChange: (state: State) => setLoading(state === State.Loading),
      authorizationToken: ``,
      projection: projection,
      format: new MVT(),
      tileGrid: tileGrid,
    }),
  );

  useEffect(() => {
    if (quarter) {
      routeLineTileSource.setUrl(buildUrl(quarter));
    }
  }, [quarter]);

  return (
    <VectorTile
      source={routeLineTileSource}
      style={routeLineStyle}
      zIndex={10000}
      visible={visible}
    />
  );
};

export default RouteLineVectorTileLayer;
